import React from 'react';

import { IndividualBrandPurchaseData } from 'modules/brand/BrandPurchaseData';
import { IndividualEnterprisePurchaseData } from 'modules/enterprise/components/purchase-history';
import { BrandVenues } from 'modules/enterprise/types';
import {
  ExperienceEntityType,
  PageHeader,
  useExperienceEntityVenues,
  useExperienceModuleContext,
} from 'modules/experience-core';
import { IndividualMerchantPurchaseData } from 'modules/merchant/components/MerchantPurchaseData';

import { mapExperienceEntityTreeToBrandVenues } from './utils';

export const ExperiencePurchaseData = () => {
  const {
    experienceEntity: { experienceEntityType, experienceEntityObject },
    experienceEntityTree,
  } = useExperienceModuleContext();
  const experienceEntityVenues = useExperienceEntityVenues();
  const venues = experienceEntityVenues.map(venue => venue.experienceEntityObject);
  if (experienceEntityType === ExperienceEntityType.ENTERPRISE) {
    const brandsVenues: BrandVenues[] = mapExperienceEntityTreeToBrandVenues(experienceEntityTree);
    return (
      <>
        <PageHeader enableSelector={false} />
        <IndividualEnterprisePurchaseData enterprise={experienceEntityObject} brandsVenues={brandsVenues} />
      </>
    );
  }

  if (experienceEntityType === ExperienceEntityType.BRAND) {
    return (
      <>
        <PageHeader enableSelector={false} />
        <IndividualBrandPurchaseData brand={experienceEntityObject} venues={venues} />
      </>
    );
  }

  if (experienceEntityType === ExperienceEntityType.MERCHANT) {
    return (
      <>
        <PageHeader enableSelector={false} />
        <IndividualMerchantPurchaseData merchant={experienceEntityObject} venues={venues} />
      </>
    );
  }

  return null;
};
